import { Common_Enums_Network } from '@m3-tech/boss5-api-types/enums'

type PrivacyPolicyAccessFields = {
    networkId?: number | null
    isTop?: boolean
    officeAdminID?: number | null
    franchiseAdminID?: number | null
}

// Mirrors legacy mortgageboss_web feature.management.js:
//   !checkIfMPH(networkId) && (isTop || officeAdminID || franchiseAdminID)
export function canAccessBrokerPlatformPrivacyPolicy(
    employee: PrivacyPolicyAccessFields | undefined,
): boolean {
    if (!employee) return false
    if (employee.networkId === Common_Enums_Network.MPH) return false
    return Boolean(employee.isTop || employee.officeAdminID || employee.franchiseAdminID)
}
